// extracted by mini-css-extract-plugin
export default {"box":"index_box__9q36s","cont":"index_cont__xBIgI"};